module.exports = __webpack_public_path__ + "img/access-denied.9304f967.webp";